//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const fallback = {
  nombre: null,
  apellidos: null,
  email: null,
  desarrollo: null,
  telefono: null,
  curp: null,
}


export default {
  props: {
    prospecto: {
      required: true,
      type: Object,
      default() {
        return fallback
      }
    },
    disable: {
      type: Boolean,
      default() {
        return false
      }
    },
    readonly: {
      type: Boolean,
      default() {
        return false
      }
    }
  },

  data() {
    return {
      desarrollos: [
        'San Lorenzo', 'Amores'
      ]
    }
  }
}
